const currentEnvironment = {
    development: {
        url: 'http://localhost:3001/dev/api/v1',
        paymentGateway: 'http://localhost:3000',
    },
    staging: {
        url: 'https://api-staging.gemplex.tv/api',
        paymentGateway: 'https://payment-staging.gemplex.tv',
    },
    production: {
        url: 'https://api.myjson.com/',
        paymentGateway: 'https://payment.gemplex.tv',
    },
};

export default process.env.REACT_APP_API_URL === 'development' ? currentEnvironment.development
    : process.env.REACT_APP_API_URL === 'staging'
        ? currentEnvironment.staging
        : currentEnvironment.development;
